// extracted by mini-css-extract-plugin
export default {"meals":"AvailableMeals_meals__pGC-9","meals-appear":"AvailableMeals_meals-appear__JMbCQ"};